<template>
	<div>
		<div class="tw-text-3xl tw-font-bold" v-if="!isDone">
			{{ $t('integrations.link-odoo-title') }}
		</div>
		<div class="tw-flex tw-items-center tw-gap-2" v-else>
			<div class="tw-text-3xl tw-font-bold">
				{{ $t('integrations.odoo-linked-title') }}
			</div>
			<div
				class="'tw-border-secondary-500 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-secondary-500 tw-text-white"
				style="width: 32px; height: 32px"
			>
				<AppIcon name="check" />
			</div>
		</div>
		<div class="tw-font-medium tw-text-gray-500" v-if="!isDone && !loading">
			{{ $t('integrations.link-odoo-description') }}
		</div>
		<div class="tw-font-medium tw-text-gray-500" v-else-if="!loading">
			{{ $t('integrations.odoo-linked-description') }}
		</div>
		<AppForm
			@submit="onSubmit"
			class="tw-mt-3 tw-flex tw-flex-col tw-gap-2"
			v-if="!isDone && !loading"
			style="width: 90%"
		>
			<div class="tw-grid tw-grid-cols-2 tw-gap-4">
				<AppInput
					v-model="form.username"
					:label="$t('integrations.username')"
					:rules="['required']"
					:disabled="loading"
				/>
				<AppInput
					v-model="form.password"
					:label="$t('integrations.password')"
					:rules="['required']"
					:disabled="loading"
				/>
			</div>

			<div class="tw-grid tw-grid-cols-2 tw-gap-4">
				<AppInput
					v-model="form.db"
					:label="$t('integrations.database')"
					:rules="['required']"
					:disabled="loading"
				/>
				<AppInput
					v-model="form.odoo_url"
					:label="$t('integrations.odoo-url')"
					:rules="['required']"
					:disabled="loading"
				/>
			</div>

			<div class="tw-mt-5">
				<AppButton
					:label="$t('integrations.confirm-data')"
					size="xl"
					endIcon="arrow-narrow-right"
					class="tw-rounded-full !tw-px-6"
					type="submit"
					:disabled="loading"
				/>
			</div>
		</AppForm>
		<div class="tw-mt-5 tw-flex tw-items-center tw-gap-3" v-else>
			<AppButton
				v-if="loading && !isDone"
				:label="$t('integrations.pending-connection')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				disabled
			/>
			<AppButton
				v-if="isDone"
				:label="$t('integrations.next-step')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
				@click="nextStep"
				:disabled="nextStepLoading"
			/>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { Marketplace } from '../../../../entities/marketplace';
import { marketplaceStepStatusEnum } from '../../helper';

const linkMarketplaceStore = useLinkMarketplaceStore();

const form = ref({
	username: '',
	password: '',
	odoo_url: '',
	db: '',
});

const formLoading = ref(false);

const loading = computed(
	() =>
		formLoading.value ||
		linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.InProgress,
);
const isDone = computed(
	() => linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);

const onSubmit = async () => {
	formLoading.value = true;
	try {
		const success = await Marketplace.setOdooDetails(form.value);
		if (!success) {
			document.location.href = '/store/subscribe/renew_package';
		}
	} finally {
		formLoading.value = false;
	}
	await linkMarketplaceStore.refetchSteps();
};

const nextStepLoading = ref(false);
const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
